import { FlexColumn } from '@editor/components/utilities/layouts';
import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

export const SimpleSurveyContainer = styled(FlexColumn)`
  padding: var(--spacing-48) var(--spacing-20);

  ${QUERIES.largeTabletAndUp} {
    padding: 72px;
  }
`;

export const FullScreenModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: var(--color-bg-surface);
`;
